import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, ButtonGroup, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import Calendar from 'assets/icon/calendar-icon.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Field, Formik } from 'formik';
import ReactSelect from 'react-select';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Drawer from 'components/Drawer';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import AddDrugExclusion from '../AddDrugExclusion';
import useContextService from 'hooks/useContextService';
import { Option, LimitedChipsContainer } from 'components/Options';
import useAxios from 'hooks/useAxios';
import { cloneDeep } from 'lodash';
import plus from "assets/icon/plus-icon.svg";
import reseticon from "assets/icon/reset.svg";
import { ModuleAccess } from 'utils/moduleaccess';



let hasDatePopupOpen = false;

let tableDataBackup = [
    {
        chainPharmacy:"123445",
        pharmacy:"123445",
        npi:"123445",
        ncpdPandNABP:"123445",
        pharmacyAddress:"123445",
        pharmacyLiveDate:"123445",
        pharmacyTerminationDate:"123445",
        claimsProcessDate:"123445",

    }
];
let rowForEdit = {};
let updatedFields = {};
let coveredEntityError = "Covered Entity Name is a required field";
let accumulationError = "Accumulator is a required field";

let coveredEntitiesData = [];
let accumulationData = [];
let hospitalData=[];
const SearchContainer = (props) => {
    const API = useAxios();


    const {
        states: { drugExclusion },
        setStates,
        resetStates,
      } = useContextService();
    const { coveredEntity,searchTerms,accumulations } =drugExclusion
    let {
      coveredEntityIDs,
      coveredEntityID,
      accumulationIDs,
      // hospitalDD
    } = searchTerms;
      const updateStates = (drugExclusion) => {
        setStates("drugExclusion", drugExclusion);
      };
      const { orgId, onReset,onSearch,refetch,filters,handleSubmit1,reset } = props;
    
    const [tableData, setTableData] = useState(tableDataBackup);
    const [data, setData] = useState(tableDataBackup);
    const [activeButton, setActiveButton] = useState("All");
    const [addDrugExclusion , setAddDrugExclusion] = useState(false);
    const [hasACCSelected, setACCSelected] = useState(true);
    const [hasCESelected, setCESelected] = useState(true);
    const [isSubmited, serIsSubmitted] = useState(false);
    const [selectedCEOption, setCEOptionSelected] = useState({
        optionCESelected: "-1",
      });
      const[accumualator,setAccumualator]=useState("");
      const[Covered,setCovered]=useState("");

    const [selectedACCOption, setOptionACCSelected] = useState({
        optionACCSelected: "-1",
      });
      const [loading, setLoading] = useState(false);

      const [collapseSider, setcollapseSider] = useState(false);
      const [hospitalErr, setHospitalErr] = useState("");
      const [selectedHospital,setHospitalselected]=useState({})
      useEffect(() => {
        setCESelected(true);
        setACCSelected(true);   
        coveredEntitiesData = [];
        accumulationData = [];
        hospitalData=[];
        drugExclusion.searchTerms.coveredEntityIDs = {};
        drugExclusion.searchTerms.accumulationIDs = {};
        drugExclusion.accumulations = [];
        updateStates(drugExclusion);
        setCEOptionSelected({optionCESelected:'-1'});
        setOptionACCSelected({optionACCSelected:'-1'});
        // setHospitalselected('');
        // setOrderStatusSelected('');
        // setPONumber('');
        fetchCoveredEntities();
        serIsSubmitted(false);
        setAddDrugExclusion(false);

      },[orgId , reset]);

// useEffect(()=>{
//     setAddDrugExclusion(false);
// },[orgId])


      const fetchCoveredEntities = async () => {
        //let { organizationID } = orgId;
        if (typeof orgId !== "undefined" && orgId !== null) {
            coveredEntitiesData = [];
            drugExclusion.searchTerms.coveredEntityIDs = [];
            updateStates(drugExclusion);

            let selectedOrgId = orgId?.organizationID;

            setLoading(false);
            try {
                const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
                    hasDefaultURL: true,
                });
                setLoading(false);
                if (data) {
                    for (var x in data) {
                        coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
                    }
                    console.log(data, "Data");
                    drugExclusion.coveredEntities = data;

                    if (coveredEntitiesData.length == 1) {
                        var ceData = [];
                        ceData.push(coveredEntitiesData[0])
                        drugExclusion.searchTerms.coveredEntityIDs = ceData;
                        window.selectedCoveredEntittyId = ceData;
                    }
                    if(window.selectedCoveredEntittyId.length > 0 ){
                      drugExclusion.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
                    }
                    updateStates(drugExclusion);
                    if (drugExclusion.searchTerms.coveredEntityIDs) {

                        var ceSelected = [];
                        ceSelected.optionCESelected = [];
                        for (var x in drugExclusion.searchTerms
                            .coveredEntityIDs) {
                            ceSelected.optionCESelected.push(
                                drugExclusion.searchTerms.coveredEntityIDs[x]
                            );
                        }
                        setCEOptionSelected(ceSelected);
                        let ceIds = drugExclusion.searchTerms.coveredEntityIDs.map(item => item["value"]);
                        onSearch(ceIds[0])
                        //fetchAccumulatorName(ceIds);
                        setCovered(ceIds);
                    }

                }
            }
            catch (err) {
                setLoading(false);
            }
        }

    };
    const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {
        let selected = [selectedces == null ? []: selectedces]
        debugger;
        if (selected) {
            window.selectedCoveredEntittyId = selected;
            accumulationData = [];
            // setSelectedNdc('');
            drugExclusion.searchTerms.accumulationIDs = {};
            setCESelected(true);
            setCEOptionSelected({
                optionCESelected: selected.value
            });
            let val = selected.value;
            drugExclusion.coveredEntities = selected;
            setFieldValue('coveredEntityIDs', selected);
            drugExclusion.searchTerms.coveredEntityIDs = selected;
            if (Array.isArray(drugExclusion.searchTerms.coveredEntityIDs)) {
                accumulationIDs = {};
                drugExclusion.searchTerms.accumulationIDs = {};
            }
            let ceIds = drugExclusion.searchTerms.coveredEntityIDs.map(item => item["value"]);
            //drugExclusion.searchTerms.coveredEntityIDs = ceIds;
            updateStates(drugExclusion);
           // fetchAccumulatorName(ceIds);
           onSearch(selected[0].value);
            setOptionACCSelected({ optionACCSelected: '-1' });
            setCovered(selected[0].value);
            // setCovered(ceIds);

        }
        else {
            setFieldValue('coveredEntityIDs', {});
            accumulationData = [];
            drugExclusion.coveredEntities = [];
            drugExclusion.searchTerms.coveredEntityIDs = {};
            drugExclusion.searchTerms.accumulationIDs = {};
            setCESelected(false);
            setACCSelected(false);
        }
        updateStates(drugExclusion);
    };
    const fetchAccumulatorName = async (coveredEntityIDs) => {
      
        if (coveredEntityIDs !== undefined && coveredEntityIDs.length > 0) {
            try {
                accumulationData = [];
                const payload = [];
                payload.AccumulatorEntityList = coveredEntityIDs;
                let AccumulatorEntityList = [payload.AccumulatorEntityList]
                const result = await API.get(`SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
                    {
                        hasDefaultURL: true,
                    }
                );
                if (result) {
                    let accumulator = []
                    accumulator = result.data;
                    for (var x in accumulator) {
                        accumulationData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
                    }
                    if(accumulationData.length == 1){
                        handleAccumulatorname(accumulationData[0])
                    }
                    drugExclusion.accumulations = result.data;
                    updateStates(drugExclusion);
                    if (accumulationIDs.length > 0) {
                        var accumulatorSelected = {};
                        accumulatorSelected.optionACCSelected = [];
                        for (var x in accumulationIDs) {
                            accumulatorSelected.optionACCSelected.push(accumulationIDs[x]);
                        }
                        setOptionACCSelected({ accumulatorSelected});
                    }
                }
            } catch (error) {
                console.log(error.message);
            }
        }
    };
    const handleAccumulatorname = (selectedacs, setFieldValue, ac) => {
      // debugger;
      let selected = [selectedacs == null ? [] : selectedacs]
        if (selected) {
            setACCSelected(true);
            setOptionACCSelected({
                optionACCSelected: selected
            })
            //   let val = selected.value;
            //   setFieldValue('accumulatorID', val);
            //   setFieldValue('accumulationIDs', selected);
            drugExclusion.searchTerms.accumulationIDs = selected;
            // fetchHospital(selected);
            setAccumualator(selected[0].value);
        }
        else {
            setACCSelected(true);
            //   setFieldValue('accumulationIDs', {});
            accumulationData = [];
            drugExclusion.coveredEntities = [];
            drugExclusion.searchTerms.accumulationIDs = {};
            drugExclusion.searchTerms.coveredEntityIDs = {};
            setCESelected(false);
        }
        updateStates(drugExclusion);
    };
    //     let { organizationID } = orgId; //The function starts by extracting organizationID from orgId.
    //     if (organizationID !== -1) {
    //       //If organizationID is not -1, it proceeds with the following steps.
    //       coveredEntitiesData = []; //It initializes coveredEntitiesData as an empty array
    //       drugExclusion.searchTerms.coveredEntityIDs = {}; //resets drugExclusion.searchTerms.coveredEntityIDs to an empty object.
    //       updateStates(drugExclusion); //updates the state of drugExclusion using updateStates(drugExclusion).
    
    //       let selectedOrgId = orgId.organizationID;
    
    //       ////setLoading(false); //It sets the loading state to false initially.
    //       try {
    //         const { data } = await API.get(
    //           `SBConfig/coveredentity/list/${selectedOrgId}`,
    //           {
    //             hasDefaultURL: true,
    //           }
    //         );
    //         ////setLoading(false);
    //         if (data) {
    //           //For each item in the fetched data, it pushes an object containing coveredEntityID and coveredEntityName into coveredEntitiesData.
    //           for (var x in data) {
    //             coveredEntitiesData.push({
    //               value: data[x].coveredEntityID,
    //               label: data[x].coveredEntityName,
    //             });
    //           }
    //           drugExclusion.coveredEntities = data; //It updates drugExclusion.coveredEntities with the fetched data.
    //           //If there is only one covered entity, it sets drugExclusion.searchTerms.coveredEntityIDs and window.selectedCoveredEntittyId to this single entity.
    //           if (coveredEntitiesData.length == 1) {
    //             var ceData = [];
    //             ceData.push(coveredEntitiesData[0]);
    //             drugExclusion.searchTerms.coveredEntityIDs = ceData;
    //             window.selectedCoveredEntittyId = ceData;
    //           }
    //           //If window.selectedCoveredEntittyId has any items, it sets drugExclusion.searchTerms.coveredEntityIDs to window.selectedCoveredEntittyId.
    //           // if (window.selectedCoveredEntittyId.length > 0) {
    //           //   drugExclusion.searchTerms.coveredEntityIDs =
    //           //     window.selectedCoveredEntittyId;
    //           // }
    //           //It updates the state of drugExclusion again using updateStates(drugExclusion).
    //           updateStates(drugExclusion);
    //           //If drugExclusion.searchTerms.coveredEntityIDs is not empty, it creates an object ceSelected with an array optionCESelected containing the selected covered entities.
    //           if (drugExclusion.searchTerms.coveredEntityIDs) {
    //             var ceSelected = [];
    //             ceSelected.optionCESelected = [];
    //             for (var x in drugExclusion.searchTerms.coveredEntityIDs) {
    //               ceSelected.optionCESelected.push(
    //                 drugExclusion.searchTerms.coveredEntityIDs[x]
    //               );
    //             }
    //             setCEOptionSelected(ceSelected); //It sets this object using setCEOptionSelected(ceSelected).
    //             //It maps the coveredEntityIDs to an array of their values
    //             let ceIds = drugExclusion.searchTerms.coveredEntityIDs.map(
    //               (item) => item["value"]
    //             );
    //             // Calls fetchAccumulationName(ceIds) with this array.
//     const fetchHospital = async(selected)=>{
//       debugger;
//       try{
//           const {data} = await API.get(`SBConfig/coveredentity/hospitallist/${selected[0].value}`,
//               {
//                   hasDefaultURL: true,
//               }
//           );
//           if(data){
//               debugger;
//               for(var x in data){
//                 hospitalData.push({id:data[x].accountGroupID,description:data[x].accountGroupName})
//               }
//           }
//       }
//       catch{
// // setLoading(false);
//       }
//   }
  // const handleHospitalChange = (e, setFieldValue) => {
  //   if (e){
  //     setHospitalErr("")
  //     const { value } = e.target;
  //     setFieldValue('hospitalDD', value);
  //     setHospitalselected(value)
  //     drugExclusion.searchTerms.hospitalDD = value;
  //     updateStates(drugExclusion);
  //   }
  //   else{
  //     setFieldValue('hospitalDD', {});
  //     drugExclusion.coveredEntities = [];
  //         drugExclusion.searchTerms.accumulationIDs = {};
  //     drugExclusion.searchTerms.hospitalDD = {};
  //     setACCSelected(true);

  //   }
  //     // console.log(value,"Account")
  // };
    const handleSubmit = async (val, actions) => {
      // debugger;
        serIsSubmitted(true);
        const { setSubmitting } = actions;
        let acIDs = [];
        let ceIDs = [];
        //let phIDs = [];
    
        if (searchTerms.coveredEntityIDs.length > 0) {
          val.coveredEntityIDs = searchTerms.coveredEntityIDs;
          setCESelected(true);
        }
        if (searchTerms.accumulationIDs.length > 0) {
            val.accumulationIDs = searchTerms.accumulationIDs;
            setACCSelected(true);
          }
    
        for (var x in val.accumulationIDs) {
          var rw = val.accumulationIDs[x];
          acIDs.push(rw.value);
        }
        for (var x in val.coveredEntityIDs) {
          var rw = val.coveredEntityIDs[x];
          ceIDs.push(rw.value);
        }
        // for (var x in val.pharmacyIds) {
        //   var rw = val.pharmacyIds[x];
        //   phIDs.push(rw.value);
        // }
      //   if(selectedHospital.length==0){
      //     setHospitalErr("Please Select the Hospital")
      // }
      // if(selectedHospital.length>0)
      //   {
      //       setHospitalErr("")
      //   }
        if (ceIDs.length == 0) {
          setCESelected(false);
          if (acIDs.length == 0) {
              setACCSelected(false);
          }
          return setSubmitting(false);
      }
      // debugger;
      // if (selectedHospital != "" && selectedHospital != undefined && accumualator != "" && accumualator != undefined){

        const values = cloneDeep(val);
    
        // if (ceIDs > [0]) values.coveredEntityIDs = val.coveredEntityIDs;
        if (ceIDs > [0]) values.CoveredEntityIDs = ceIDs;
        if (acIDs > [0]) values.accumulationIDs = acIDs;
        // if (hospitalDD) values.hospitalDD = hospitalDD;

        // if (selectedHospital) {
        //   values.hospitalDD = selectedHospital;
        // }
        // else {
        //     values.hospitalDD = 0;
        // }
        // values.hospitalDD = hospitalDD;
        drugExclusion.search.currentPage = 1;
        updateStates(drugExclusion);
        await onSearch(values);
        setSubmitting(false);
      // }
      };
      const handleReset = ({ resetForm }) => {
        serIsSubmitted(false);
        setCESelected(true);
        setACCSelected(true);
        // setHospitalselected("");
        // setHospitalErr("")
        accumulationData = [];
        // hospitalData=[];
        window.selectedCoveredEntittyId = "";
        // resetForm();
        onReset();
        setCEOptionSelected({ optionCESelected: "-1" });
        setOptionACCSelected({ optionACCSelected: "-1" });
        drugExclusion.searchTerms.coveredEntityIDs = {};
        drugExclusion.searchTerms.accumulationIDs = {};
        updateStates(drugExclusion);
        resetStates("drugExclusion");
      }
    const toggleAddDrugExclusion = () => {
        setAddDrugExclusion(!addDrugExclusion);
        // refetch();
      };
      const handelDrugExclusion=()=>{
        toggleAddDrugExclusion()
      }

    
    const handelAddCrosswalk=async()=>{
        await addCrosswalk()
    }

   
    const renderEditButton = () => {
        // if (hasPermission('EDT'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => ""}
                title='Edit Covered Entity'

            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    const cellRenderEdit = (rowData) => {

        if (rowData.isEdit) {
            return (
                <div className='d-flex align-items-center'>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={savePanelUpdateRow}
                    >
                        <HoverImage
                            key='SaveIcon'
                            src={SaveIcon}
                            hoverSrc={SaveHoverIcon}
                            alt=''
                        />
                    </Button>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={() => editRow(rowData, false)}
                    >
                        <HoverImage
                            key='CancelIcon'
                            src={CancleIcon}
                            hoverSrc={CancleHoverIcon}
                            alt=''
                        />
                    </Button>
                </div>
            );
        } else {

            return (
                <div className='d-flex align-items-center'>
                    {renderEditLButton1(rowData)}

                </div>
            );
        }
    };
    const renderEditLButton1 = (rowData) => {
        // if (hasPermission('EPLS'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'

                onClick={() => editRow(rowData)}
                title='Edit Location'


            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    const editRow = (rowData, isEdit = true) => {

        let tempData = [...data];
        tempData = tempData.map((row) => {
            row.isEdit = false;
            if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
                row.isEdit = isEdit;
                rowForEdit = row;
            }
            return row;
        });
        // setTouched('');
        // setSelectedStatus('');
        updatedFields = {};
        //  tableDataBackup = tempData;
        setData(tempData);
    };
    const savePanelUpdateRow = async () => {
console.log("krishna")
    };

    const hasPermission = (code) => {
          return ModuleAccess("DRC", code);
      }
    const updateRowValue = (value, col) => {

        const tempRow = { ...rowForEdit };
        tempRow[col] = value;
        rowForEdit = tempRow;
    };
    const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {

        return (
            <CellEditRender
                row={row}
                col={col}
                formatterType={formatterType}
                onChange={updateRowValue}
                alwaysEditableCheckbox={alwaysEditableCheckbox}
            />
        );
    };

   
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {

        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleButtonClick = (button) => {
      setActiveButton(button);
    };
console.log(Covered,"Covered In SearchContainer")
    let addDisable = selectedCEOption.optionCESelected != '-1'  && drugExclusion.searchTerms.coveredEntityIDs.length > 0  ? false : true;

    // console.log(accumulationIDs,"Acc id")
    // console.log(,"Acc id")

  return (
    <div>
      <Formik
        initialValues={searchTerms}
        onSubmit={handleSubmit}
        // validationSchema={validationSchema}
        // enableReinitialize={true}
        children={(props) => {
          const {
            isSubmitting,
            handleSubmit,
            resetForm,
            setFieldValue,
            errors,
            touched,
          } = props;
          return (
            <div hidden={collapseSider}>
               <div className="d-flex justify-content-between">
                <h5 className="f-16 text-primary font-weight-700">
                  Search Drug Exclusions
                </h5>
                <div>
                   <Button
                    hidden={(hasPermission('AD'))}
                   // disabled={isSubmitting}
                   color="primary"
                   className="reset addbtn"
                   onClick={handelDrugExclusion}
                   disabled={addDisable}
                  // hidden={!hasPermission("AD")}
                 >
                     <span className="right_5">
                        <img src={plus} alt="" />
                      </span>{" "}
                   Add
                 </Button>
                </div>
              </div>
              <div>
                <Row sm={5} className="d-flex" style={{}}>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="coveredentity">Covered Entity</Label>
                      <ReactSelect
                        name="coveredentity"
                        id="coveredentity"
                        options={coveredEntitiesData}
                        // isMulti
                        closeMenuOnSelect={true}
                        // hideSelectedOptions={false}
                        // optionSelected={true}
                        // isClearable={true}
                        components={{
                          Option,
                        }}
                        isSearchable="true"
                        onChange={(value, cp) =>
                          handleCoverdEntityChange(value, setFieldValue, cp)
                        }
                        value={selectedCEOption.optionCESelected}
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                        }}
                      />
                      {!hasCESelected ? (
                        <div className="text-danger f-12 position-absolute">
                          {coveredEntityError}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  {/* <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="accumulator">Accumulator</Label>
                      <ReactSelect
                        name="accumulator"
                        id="accumulator"
                        options={accumulationData}
                        // isMulti
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        isClearable={true}
                        components={{
                          Option,
                        }}
                        // isSearchable="true"
                        onChange={(value, ac) =>
                          handleAccumulatorname(value, setFieldValue, ac)
                        }
                        value={selectedACCOption.optionACCSelected}
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                        }}
                      />
                      {(!hasACCSelected && isSubmited) ||
                      (hasCESelected &&
                        isSubmited &&
                        selectedACCOption.optionACCSelected == "-1") ? (
                        <div className="text-danger f-12 position-absolute">
                          {accumulationError}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col> */}
                  {/* <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="hospitalname">Hospital Name </Label>
                      <Field
                        id="hospitalname"
                        name="hospitalname"
                        className="required"
                        type="select"
                        placeholder="Select Hospital Name "
                        autoComplete="off"
                        options={hospitalData}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        hidden
                        component={FormikSelectField}
                        onChange={(e) => handleHospitalChange(e, setFieldValue)}
                        defaultoption="--Select--"
                        keys={{
                          id: "id",
                          label: "description",
                        }}
                      />
                      {hospitalErr && (
                        <div className="text-danger font-size-12">
                          {hospitalErr}
                        </div>
                      )}
                    </FormGroup>
                  </Col> */}
                </Row>
              </div>
              <div hidden={""}>
                <Row
                  style={{
                    justifyContent: "flex-end",
                    // marginRight: "10px",
                  }}
                >
                  <Col sm={2} className="d-flex justify-content-end">
                    <Label>{""}</Label>
                    {/* <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className=""
                      onClick={handelDrugExclusion}
                      disabled={addDisable}
                      // hidden={!hasPermission("ADD")}
                    >
                      Add
                    </Button> */}
                    <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className=""
                      
                      onClick={handleSubmit}

                      // disabled={!coveredEntityid}
                      hidden={true}
                      
                    >
                      Search
                    </Button>
                    <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className="reset"
                      onClick={handleReset}

                      // hidden={!hasPermission("ADD")}
                    >
                      <span className="right_5">
                      <img src={reseticon} alt="" />
                    </span>{" "}
                      Reset
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          );
        }}
      ></Formik>

      <Drawer
        direction="end"
        title="Add Drug Exclusion"
        isOpen={addDrugExclusion}
        toggle={toggleAddDrugExclusion}
        size="lg"
      >
        <AddDrugExclusion
        selectedHospital={selectedHospital}
        accumualator={accumualator}
          toggle={toggleAddDrugExclusion}
          orgId={orgId}
          refetch={refetch}
          onSearch={onSearch}
          filters={filters}
          handleSubmit1={handleSubmit1}
          Covered={Covered}
        />
      </Drawer>
    </div>
    
  );
}

export default SearchContainer
